<template>
  <el-dialog
    v-el-drag-dialog
    v-loading="loading"
    :visible.sync="innerVisible"
    :title="$t('AirExport.FlightSelection')"
    width="850px"
    :close-on-click-modal="false"
    append-to-body
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <el-form :inline="true" label-width="100px" label-position="left">
      <el-form-item :label="$t('SeaExport.FlightNo')">
        <el-input v-model="filter.flightNo" style="width: 180px;" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.AirlineCompany')">
        <cargo-advance-select
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{airCmp:true}"
          :show-custom-label-in-option="true"
          :custom-label="airCompanyLabel"
          filterable
          :default-value="filter.carrierId||''"
          style="display: inline-block;width: 280px;"
          @parentCallBack="p=>{filter.carrierId=p.value||0}"
        />
      </el-form-item>
    </el-form>
    <el-form :inline="true" label-width="100px" label-position="left">
      <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')">
        <cargo-advance-select
          :select-type="TYPE_NAMES.basic_data_Airport"
          filterable
          :default-value="filter.loadingPortCode"
          style="display: inline-block;width: 180px;"
          @parentCallBack="p=>{filter.loadingPortCode=p.value}"
        />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
        <cargo-advance-select
          :select-type="TYPE_NAMES.basic_data_Airport"
          filterable
          :default-value="filter.destinationPortCode"
          style="display: inline-block;width: 210px;"
          @parentCallBack="p=>{filter.destinationPortCode=p.value}"
        />
        <el-button type="primary" style="margin-left: 5px;" @click="queryHandler">{{ $t('SeaExport.Query') }}</el-button>
      </el-form-item>
    </el-form>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="height: 350px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import $store from '@/store'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { queryFlights } from '@/api/booking/flightDescription'
import lang from '@/lang'

const CNWeek = [lang.t('AirExport.Monday'), lang.t('AirExport.Tuesday'), lang.t('AirExport.Wednesday'), lang.t('AirExport.Thursday'), lang.t('AirExport.Friday'), lang.t('AirExport.Saturday'), lang.t('AirExport.Sunday')]

export default {
  name: 'FlightDescriptionSelectDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: false,
      TYPE_NAMES,
      filter: {
        branchId: 0,
        flightNo: '',
        carrierId: 0,
        loadingPortCode: '',
        destinationPortCode: ''
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.FlightNo'),
          field: 'flightNo',
          width: 100
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'loadingPortCode',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          width: 100
        }, {
          headerName: this.$t('AirExport.FlightSchedule'),
          field: 'flightScheduleItem',
          width: 180,
          valueGetter: params => {
            const items = params.data.flightScheduleItem
            if (items && items.length > 0) {
              let s = this.$selectByLang(this.$t('AirExport.Weekly'), '')
              const indexs = []
              for (const item of items) {
                indexs.push(Number(item.itemName))
              }
              indexs.sort()
              for (const index of indexs) {
                s += ' ' + CNWeek[index]
              }
              return s
            }
            return ''
          }
        }, {
          headerName: this.$t('Pricing.BeginDate'),
          width: 180,
          valueGetter: params => {
            const data = params.data
            let s = ColumnUtils.formateDateToString(data.beginValidDate, 'yyyy/MM/dd')
            if (data.endValidDate) {
              s += ' - ' + ColumnUtils.formateDateToString(data.endValidDate, 'yyyy/MM/dd')
            }
            return s
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    airCompanyLabel(item) {
      if (item) {
        const filedName = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
        return '[' + item.shortName + ']' + item[filedName]
      }
      return ''
    },
    queryHandler() {
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = true
      queryFlights(this.filter).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    clickHandler() {
      if (!this.selectedNode) {
        this.$message.warning(this.$t('AirExport.PleaseSelectAFlight'))
        return
      }
      this.$emit('callback', this.selectedNode.data)
      this.innerVisible = false
    }
  }
}
</script>
